import { useSyncExternalStore } from 'react';

type Snapshot = {
  id: string | null;
  content: string;
  active: boolean;
};

let state: Snapshot = {
  id: null,
  content: '',
  active: false,
};

const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((l) => l());
}

export const streamingStore = {
  setActive(id: string, initialContent = '') {
    state = { id, content: initialContent, active: true };
    emit();
  },
  append(text: string) {
    if (!state.active) return;
    state = { ...state, content: state.content + text };
    emit();
  },
  setContent(text: string) {
    if (!state.active) return;
    state = { ...state, content: text };
    emit();
  },
  end() {
    state = { ...state, active: false };
    emit();
  },
  clear() {
    state = { id: null, content: '', active: false };
    emit();
  },
  getSnapshot(): Snapshot {
    return state;
  },
  subscribe(listener: () => void) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

export function useStreamingContent(
  streamingMessageId?: string,
  isStreaming?: boolean
): string | null {
  return useSyncExternalStore(
    streamingStore.subscribe,
    () => {
      if (!isStreaming || !streamingMessageId) return null;
      const s = streamingStore.getSnapshot();
      if (s.active && s.id === streamingMessageId) return s.content;
      return null;
    },
    () => null
  );
}
